<template>
    <kiosk-layout v-if="loading">
        <page-loading />
    </kiosk-layout>

    <kiosk-team-term-details v-else-if="term" :teamId="props.teamId" :term="term">
        <div class="flex flex-col gap-6 w-full max-w-(--breakpoint-sm)">
            <term-acceptances :teamId="props.teamId" :term="term" />
        </div>
    </kiosk-team-term-details>

    <kiosk-layout v-else>
        <vx-alert color="danger" :closeable="false">Unable to load the Terms.</vx-alert>
    </kiosk-layout>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { VxAlert } from '@voxie/frontend-components';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import { useToasted } from '~/composables/useToasted';
import { adminTermsClient } from '~/services';
import { catchRequestError } from '~/utils/request';
import type { Term } from '~/services/adminTermsClient.types';
import KioskTeamTermDetails from './KioskTeamTermDetails.vue';
import TermAcceptances from './TermAcceptances.vue';

const props = defineProps<{
    teamId: number;
    termId: number;
}>();

const toasted = useToasted();
const loading = ref(true);
const term = ref<Term | null>(null);

onMounted(async () => {
    try {
        const response = await adminTermsClient.getTerm(props.teamId, props.termId);
        term.value = response.data;
    } catch (error) {
        toasted.error(catchRequestError(error));
    } finally {
        loading.value = false;
    }
});
</script>
